import { TranslationKeys } from './translationKeys';

export const ALL_GAMES_COLUMN_ID = 1;
export const THIS_GAMES_COLUMN_ID = 2;
export const HISTORY_COLUMN_ID = 3;
export const HIGH_ROLLERS_COLUMN_ID = 4;
export const LIVE_BETS_COLUMN_HEADER = [
  {
    title: TranslationKeys.AllGames,
    id: ALL_GAMES_COLUMN_ID,
  },
  {
    title: TranslationKeys.ThisGame,
    id: THIS_GAMES_COLUMN_ID,
  },
  {
    title: TranslationKeys.History,
    id: HISTORY_COLUMN_ID,
  },
  {
    title: TranslationKeys.HighRollers,
    id: HIGH_ROLLERS_COLUMN_ID,
  },
];
